import React from 'react';
import { Shield } from 'lucide-react';
import ModuleTabHeader from '../../../components/common/ModuleTabHeader';

export type VaultTabKey = 'sops' | 'risks';

export interface VaultTabMeta {
  key: VaultTabKey;
  label: string;
}

export const vaultTabs: VaultTabMeta[] = [
  { key: 'sops', label: 'SOPs' },
  { key: 'risks', label: 'Risks' },
];

interface VaultTabsProps {
  activeTab: VaultTabKey;
  onTabChange: (key: VaultTabKey) => void;
}

const VaultTabs: React.FC<VaultTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <ModuleTabHeader
      title="Vault"
      icon={<Shield size={16} strokeWidth={1.75} />}
      tabs={vaultTabs}
      activeTab={activeTab}
      onTabChange={(k: string) => onTabChange(k as VaultTabKey)}
    />
  );
};

export default VaultTabs;
